import { render, staticRenderFns } from "./LogsSection.vue?vue&type=template&id=8d5c43e2"
import script from "./LogsSection.vue?vue&type=script&lang=js"
export * from "./LogsSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports